<template>
  <ul>
    <li @click="setValue('LT')" :class="{ active: value === 'LT' }">&lt;</li>
    <li
      v-if="!withoutEqual"
      @click="setValue('EQ')"
      :class="{ active: value === 'EQ' }"
    >
      =
    </li>
    <li @click="setValue('GT')" :class="{ active: value === 'GT' }">&gt;</li>
  </ul>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: null
    },
    withoutEqual: {
      type: Boolean,
      default: false
    }
  },
  name: "NumericComparator",
  methods: {
    setValue(value) {
      this.$emit("input", value);
    }
  }
};
</script>

<style lang="scss" scoped>
ul {
  display: flex;
  margin-top: 0;
  margin-bottom: 0;
  padding: 0;
}
li {
  list-style: none;
  font-size: 1.2rem;
  text-align: center;
  border: 1px solid #ccc;
  padding: 5px 10px;
  border-left: none;
  &:first-child {
    border-left: #ccc 1px solid;
    border-bottom-left-radius: 5px;
    border-top-left-radius: 5px;
  }
  &:last-child {
    border-bottom-right-radius: 5px;
    border-top-right-radius: 5px;
  }

  &.active {
    background-color: var(--md-theme-default-primary);
    color: white;
  }
}
</style>
